import React from 'react';
import { Bluetooth } from 'assets/icons/Bluetooth';
import { Card } from 'assets/icons/Card';
import { Call } from 'assets/icons/Call';

export const CREDENTIALS = {
  Bluetooth: <Bluetooth />,
  Card: <Card />,
  FingerPrint:
  'Fingerprint',
  LicensePlate:
  'License plate',
  Pin:
  'Pin',
  QrCode:
  'QR code',
  Remote:
  'Remote unlocking',
  RemoteDtmf: <Call />,
  Rex:
  'Rex button',
};
